import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import { SurveysModule } from 'src/app/components/surveys/surveys.module';
import { SharedPipesModule } from 'src/pipes/shared-pipes.module';

import { AvatarModule } from '../../components/avatar/avatar.module';

import { AdminSurveysRoutingModule } from './admin-surveys-routing.module';
import { AdminSurveysComponent } from './admin-surveys.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    AdminSurveysRoutingModule,
    NgxDatatableModule,
    AvatarModule,
    SurveysModule,
    SharedPipesModule,
  ],
  declarations: [AdminSurveysComponent],
})
export class AdminSurveysModule {}
